<template>
  <div class="ful-page">
    <div class="ful-page-wrapper">
      <PageHeader title="自拟组方确认" subtitle="核对患者信息、症状与组方后提交订单" @back="goBack" />

      <div class="ful-card">
        <div class="ful-body ful-body-single">
          <!-- 01 基本信息 -->
          <section class="ful-section">
            <div class="ful-section-heading">
              <span class="ful-section-number">01</span>
              <h2 class="ful-section-title">基本信息</h2>
            </div>
            <div class="info-grid" v-if="consultInfo">
              <div class="info-item" v-if="!isEmptyValue(consultInfo.name)">
                <span class="info-label">姓名：</span>
                <span class="info-value">{{ consultInfo.name }}</span>
              </div>
              <div class="info-item" v-if="!isEmptyValue(consultInfo.sex)">
                <span class="info-label">性别：</span>
                <span class="info-value">{{ consultInfo.sex == '1' ? '男' : '女' }}</span>
              </div>
              <div class="info-item" v-if="!isEmptyValue(consultInfo.phoneNo)">
                <span class="info-label">电话：</span>
                <span class="info-value">{{ consultInfo.phoneNo }}</span>
              </div>
              <div class="info-item" v-if="!isEmptyValue(consultInfo.birthday) || !isEmptyValue(consultInfo.birthHour) || !isEmptyValue(consultInfo.birthMinute)">
                <span class="info-label">出生日期：</span>
                <span class="info-value">{{ consultInfo.birthday }}<!-- 出生时分 暂时隐藏（保留代码，恢复时去掉注释即可）<span v-if="shouldShowTime(consultInfo.birthHour, consultInfo.birthMinute)"> {{ formatTimeValue(consultInfo.birthHour) }}:{{ formatTimeValue(consultInfo.birthMinute) }}</span> --></span>
              </div>
              <div class="info-item" style="grid-column:1/-1" v-if="!isEmptyValue(consultInfo.liveArea)">
                <span class="info-label">常住地址：</span>
                <span class="info-value">{{ consultInfo.liveArea }}</span>
              </div>
              <div class="info-item" style="grid-column:1/-1" v-if="!isEmptyValue(consultInfo.birthArea)">
                <span class="info-label">出生地址：</span>
                <span class="info-value">{{ consultInfo.birthArea }}</span>
              </div>
              <div class="info-item" v-if="!isEmptyValue(consultInfo.useDate)">
                <span class="info-label">开始服药时间：</span>
                <span class="info-value">{{ consultInfo.useDate }}</span>
              </div>
              <div class="info-item" v-if="!isEmptyValue(consultInfo.useDays)">
                <span class="info-label">服药天数：</span>
                <span class="info-value">{{ consultInfo.useDays }}</span>
              </div>
            </div>
          </section>

          <!-- 02 症状信息 -->
          <section class="ful-section" v-if="hasBasicData || hasSanJiaoData">
            <div class="ful-section-heading">
              <span class="ful-section-number">02</span>
              <h2 class="ful-section-title">症状信息</h2>
            </div>
            <div class="symptom-list">
              <!-- 基本情况 / 脉象 -->
              <div class="symptom-group" v-if="hasBasicData">
                <div class="symptom-group-title">基本情况 / 脉象</div>
                <div class="info-grid">
                  <div class="info-item" v-for="item in basicTableArray" :key="'b'+item.key" v-if="isValidItem(item)">
                    <span class="info-label">{{ item.key }}：</span>
                    <span class="info-value">{{ formatValue(item.value) }}</span>
                  </div>
                </div>
              </div>

              <!-- 三焦辨证 -->
              <template v-if="hasSanJiaoData">
                <div class="divider"></div>
                <div class="symptom-group">
                  <div class="symptom-group-title">三焦辨证</div>
                  <div class="sanjiao-list">
                    <div class="sanjiao-group" v-if="hasValidShangJiao">
                      <div class="sanjiao-group-title">上焦</div>
                      <div class="info-grid">
                        <div class="info-item" v-for="item in shangjiaoTableArray" :key="'sj'+item.key" v-if="isValidItem(item)">
                          <span class="info-label">{{ item.key }}：</span>
                          <span class="info-value">{{ formatValue(item.value) }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="sanjiao-group" v-if="hasValidZhongJiao">
                      <div class="sanjiao-group-title">中焦</div>
                      <div class="info-grid">
                        <div class="info-item" v-for="item in zhongjiaoTableArray" :key="'zj'+item.key" v-if="isValidItem(item)">
                          <span class="info-label">{{ item.key }}：</span>
                          <span class="info-value">{{ formatValue(item.value) }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="sanjiao-group" v-if="hasValidXiaJiao">
                      <div class="sanjiao-group-title">下焦</div>
                      <div class="info-grid">
                        <div class="info-item" v-for="item in xiajiaoTableArray" :key="'xj'+item.key" v-if="isValidItem(item)">
                          <span class="info-label">{{ item.key }}：</span>
                          <span class="info-value">{{ formatValue(item.value) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </section>

          <!-- 03 自拟组方信息 -->
          <section class="ful-section">
            <div class="ful-section-heading">
              <span class="ful-section-number">03</span>
              <h2 class="ful-section-title">自拟组方信息</h2>
            </div>
            <div class="ful-collapse-content">
              <span v-if="diagnosisType">诊断类型：{{ diagnosisType }}</span>
              <span v-if="diagnoseResult">诊断结果：{{ diagnoseResult }}</span>
              <span v-if="takeMedTime">服药时间：{{ takeMedTime }}</span>
              <span v-if="useInstructions">使用方法：{{ useInstructions }}</span>
              <span v-if="taboo">禁忌：{{ taboo }}</span>
            </div>
          </section>

          <!-- 04 药品列表 -->
          <section class="ful-section">
            <div class="ful-section-heading">
              <span class="ful-section-number">04</span>
              <h2 class="ful-section-title">药品列表</h2>
            </div>
            <el-table :data="selectDrugList" :span-method="arraySpanMethod" style="width: 100%; table-layout: fixed;" :row-class-name="tableRowClassName" class="ful-el-table">
              <el-table-column label="序号" width="216">
                <template slot-scope="scope">
                  <span v-if="scope.row.value === -1" class="summary-row-total">
                    {{ scope.row.index }}
                  </span>
                  <span v-else>{{ scope.row.index }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="label" label="药品名称" width="432"></el-table-column>
              <el-table-column prop="weight" label="饮片重量(g)" width="216"></el-table-column>
              <el-table-column label="颗粒重量(g)" width="216">
                <template slot-scope="scope">
                  {{
                    scope.row.piecesWeight
                      ?Math.round(scope.row.weight*100 / scope.row.piecesWeight)/100
                      : "该饮片无颗粒"
                  }}
                </template>
              </el-table-column>
            </el-table>

            <!-- 表格外部：使用方法和禁忌（与总计行视觉连成一片） -->
            <div class="ful-info-section" v-if="useInstructions">
              <span class="info-row-label">使用方法：</span>
              <span class="info-row-value">{{ useInstructions }}</span>
            </div>
            <div class="ful-info-section" v-if="taboo">
              <span class="info-row-label">禁忌：</span>
              <span class="info-row-value">{{ taboo }}</span>
            </div>
          </section>
        </div>

        <div class="ful-actions">
          <!-- <button class="ful-btn-draft" @click="sendPrescriptionToAi" :disabled="!hasPrescriptionData">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
            一键输入到AI对话框
          </button> -->
          <button class="ful-btn-submit" @click="submit">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            创建自拟方订单
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/widgets/PageHeader.vue";
import { EventBus } from '@/js/eventbus.js'
import utils from '@/js/utils.js'
export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      tabActive: "0",
      prescriptions: [],
      tablePrescription: [],
      changeDrugList: [],
      visible: false,
      dialogDrugVisible: false,
      dialogWeightVisible: false,
      currentDrug: "",
      currentWeight: "",
      currentItem: {},
      flag: 0,
      basicTableArray: [],
      shangjiaoTableArray: [],
      zhongjiaoTableArray: [],
      xiajiaoTableArray: [],
      consultInfo: {},
      hasShangJiao: false,
      hasZhongJiao: false,
      hasXiaJiao: false,
      visitRecordId: "",
      diagnoseResult: "",
      diagnosisType: "",
      takeMedTime: "",
      useInstructions:"",
      taboo:"",
      selectDrugList: [],
    };
  },
  computed: {
    hasPrescriptionData() {
      return this.selectDrugList && this.selectDrugList.filter(item => item.value > 0).length > 0
    },
    hasValidShangJiao() {
      return (this.shangjiaoTableArray || []).some(item => this.isValidItem(item))
    },
    hasValidZhongJiao() {
      return (this.zhongjiaoTableArray || []).some(item => this.isValidItem(item))
    },
    hasValidXiaJiao() {
      return (this.xiajiaoTableArray || []).some(item => this.isValidItem(item))
    },
    hasSanJiaoData() {
      return this.hasValidShangJiao || this.hasValidZhongJiao || this.hasValidXiaJiao
    },
    hasBasicData() {
      return (this.basicTableArray || []).some(item => this.isValidItem(item))
    }
  },
  mounted() {
    this.visitRecordId = this.$route.query.visitRecordId;
    console.log("visitRecordId: " + this.visitRecordId);
    console.log(111111);
    console.log(JSON.parse(sessionStorage.getItem("consultInfo")).contact);

    if (JSON.parse(sessionStorage.getItem("consultInfo")).contact) {
      this.consultInfo = JSON.parse(
        sessionStorage.getItem("consultInfo")
      ).contact;
    } else {
      this.consultInfo = JSON.parse(sessionStorage.getItem("consultInfo"));
    }
    this.consultInfo.useDate = JSON.parse(
      sessionStorage.getItem("consultInfo")
    ).useDate;
    this.consultInfo.useDays = JSON.parse(
      sessionStorage.getItem("consultInfo")
    ).useDays;
    this.submitData = JSON.parse(sessionStorage.getItem("submitData"));
    this.basicTableArray = this.basicTableArray.concat(
      this.submitData.basic_array
    );
    this.basicTableArray = this.basicTableArray.concat(
      this.submitData.basic_enter_array
    );
    this.basicTableArray = this.basicTableArray.concat(
      this.submitData.maixiang_array
    );
    this.shangjiaoTableArray = this.submitData.shangjiao_array;
    this.zhongjiaoTableArray = this.submitData.zhongjiao_array;
    this.xiajiaoTableArray = this.xiajiao_array;
    this.selectDrugList = JSON.parse(sessionStorage.getItem("selectDrugList"));
    var handMakeInfo = JSON.parse(sessionStorage.getItem("handMakeInfo"));
    this.diagnoseResult = handMakeInfo.diagnoseResult;
    this.diagnosisType = handMakeInfo.diagnosisType;
    this.takeMedTime = handMakeInfo.takeMedTime;
    this.useInstructions = handMakeInfo.useInstructions;
    this.taboo = handMakeInfo.taboo;
    this.submitData.shangjiao_array.forEach(function (element) {
      if (element.value.length > 0) {
        that.hasShangJiao = true;
      }
    });
    this.submitData.zhongjiao_array.forEach(function (element) {
      if (element.value.length > 0) {
        that.hasZhongJiao = true;
      }
    });
    this.submitData.xiajiao_array.forEach(function (element) {
      if (element.value.length > 0) {
        that.hasXiaJiao = true;
      }
    });
    this.patientId = this.consultInfo.patientId;
  },
  methods: {
    isEmptyValue(value) {
      return value === '' || value === null || value === undefined
    },
    shouldShowTime(hour, minute) {
      return !this.isEmptyValue(hour) || !this.isEmptyValue(minute)
    },
    formatTimeValue(value) {
      if (this.isEmptyValue(value)) return '00'
      var str = String(value)
      return str.length < 2 ? '0' + str : str
    },
    isValidItem(item) {
      if (!item || !item.hasOwnProperty('value')) return false
      var val = this.formatValue(item.value)
      return val !== '' && val !== null && val !== undefined && val !== '正常'
    },
    formatValue(value) {
      if (Array.isArray(value)) {
        return value.join('，')
      }
      if (typeof value === 'string') {
        return value.replace(/,/g, '，')
      }
      return value
    },
    goBack() {
      this.$router.go(-1);
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row.value === -1 && columnIndex === 0) {
        return [1, 4];
      }
      if (row.value === -1 && columnIndex > 0) {
        return [0, 0];
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.value === -1) {
        return "total-row";
      }
      return "";
    },
    submit() {
      var newShangjiao_array = this.submitData.shangjiao_array.map(
        (obj, index) => {
          obj.value = this.submitData.shangjiao_array[index].value.toString();
          return obj;
        }
      );
      var newZhongjiao_array = this.submitData.zhongjiao_array.map(
        (obj, index) => {
          obj.value = this.submitData.zhongjiao_array[index].value.toString();
          return obj;
        }
      );
      var newXiajiao_array = this.submitData.xiajiao_array.map((obj, index) => {
        obj.value = this.submitData.xiajiao_array[index].value.toString();
        return obj;
      });
      var newSubmitData = {};
      newSubmitData.basic_array = this.submitData.basic_array;
      newSubmitData.basic_enter_array = this.submitData.basic_enter_array;
      newSubmitData.maixiang_array = this.submitData.maixiang_array;
      newSubmitData.shangjiao_array = newShangjiao_array;
      newSubmitData.zhongjiao_array = newZhongjiao_array;
      newSubmitData.xiajiao_array = newXiajiao_array;
      var prescriptionList = [];
      console.log(this.selectDrugList);
      this.selectDrugList.forEach((item) => {
        var name = item.label;
        if (name && name.length > 0) {
          prescriptionList.push({
            key: name,
            value: item.weight,
            index: item.index,
          });
        }
      });
      var prescriptionBody = {
        disease: this.diagnoseResult,
        diagnosisType: this.diagnosisType,
        prescriptionList: prescriptionList,
        take_time: this.takeMedTime,
        total: 0,
      };
      var params = {
        patientId: this.consultInfo.patientId,
        toDoDay: this.consultInfo.useDate,
        takeDays: this.consultInfo.useDays,
        useInstructions: this.useInstructions,
        taboo: this.taboo,
        inquiryInfo: newSubmitData,
        prescriptionBody: prescriptionBody,
      };
      this.wjtHttp.post(
        this,
        "/api/health/v2/prescription/commonSelf/image",
        params,
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.prescriptions = data.data.prescription.prescriptionInfos;
            var consultInfo = data.data.prescription.patient;
            consultInfo.useDate = data.data.prescription.startDate;
            consultInfo.useDays = data.data.prescription.takeDays;
            this.basicTableArray = this.basicTableArray.concat(
              data.data.prescription.inquiryInfo.basic_array
            );
            this.basicTableArray = this.basicTableArray.concat(
              data.data.prescription.inquiryInfo.basic_enter_array
            );
            this.basicTableArray = this.basicTableArray.concat(
              data.data.prescription.inquiryInfo.maixiang_array
            );
            var shangjiaoTableArray =
              data.data.prescription.inquiryInfo.shangjiao_array;
            var zhongjiaoTableArray =
              data.data.prescription.inquiryInfo.zhongjiao_array;
            var xiajiaoTableArray =
              data.data.prescription.inquiryInfo.xiajiao_array;

            sessionStorage.setItem("consultInfo", JSON.stringify(consultInfo));
            sessionStorage.setItem(
              "basicTable",
              JSON.stringify(this.basicTableArray)
            );
            sessionStorage.setItem(
              "shangjiaoTableArray",
              JSON.stringify(shangjiaoTableArray)
            );
            sessionStorage.setItem(
              "zhongjiaoTableArray",
              JSON.stringify(zhongjiaoTableArray)
            );
            sessionStorage.setItem(
              "xiajiaoTableArray",
              JSON.stringify(xiajiaoTableArray)
            );
            this.generateTableData();
            sessionStorage.setItem(
              "tablePrescription",
              JSON.stringify(this.tablePrescription)
            );
            sessionStorage.setItem("images", JSON.stringify(data.data.images));
            this.$router.replace({
              path: "/commonHandmadePrescriptionDetails",
              query: {
                visitRecordId: data.data.images[0].visitRecordId,
              },
            });
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0 ? data.msg : "提交自拟组方异常",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    parsePrescriptionToText() {
      const lines = []

      // 1. 患者信息（脱敏）
      if (this.consultInfo && this.consultInfo.name) {
        const blurredName = utils.blurName(this.consultInfo.name)
        lines.push(`患者姓名：${blurredName}`)
      }
      if (this.consultInfo && this.consultInfo.birthday) {
        lines.push(`患者生日：${this.consultInfo.birthday}`)
      }
      if (this.consultInfo && this.consultInfo.birthArea) {
        lines.push(`患者出生地址：${this.consultInfo.birthArea}`)
      }
      if (this.consultInfo && this.consultInfo.liveArea) {
        lines.push(`常住地址：${this.consultInfo.liveArea}`)
      }
      if (this.consultInfo && this.consultInfo.useDate) {
        lines.push(`开始服药时间：${this.consultInfo.useDate}`)
      }
      if (this.consultInfo && this.consultInfo.useDays) {
        lines.push(`服药天数：${this.consultInfo.useDays}`)
      }
      if (this.useInstructions) {
        lines.push(`使用方法：${this.useInstructions}`)
      }
      if (this.taboo) {
        lines.push(`禁忌：${this.taboo}`)
      }

      // 2. 诊断信息
      if (this.diagnosisType) {
        lines.push(`诊断类型：${this.diagnosisType}`)
      }
      if (this.diagnoseResult) {
        lines.push(`诊断结果：${this.diagnoseResult}`)
      }
      if (this.takeMedTime) {
        lines.push(`服药时间：${this.takeMedTime}`)
      }

      // 3. 症状信息
      const symptoms = []
      if (this.basicTableArray && this.basicTableArray.length > 0) {
        for (const item of this.basicTableArray) {
          if (item.key && item.value && item.value.length > 0) {
            symptoms.push(`${item.key}：${item.value}`)
          }
        }
      }
      if (this.shangjiaoTableArray && this.shangjiaoTableArray.length > 0) {
        for (const item of this.shangjiaoTableArray) {
          if (item.key && item.value) {
            symptoms.push(`上焦-${item.key}：${item.value}`)
          }
        }
      }
      if (this.zhongjiaoTableArray && this.zhongjiaoTableArray.length > 0) {
        for (const item of this.zhongjiaoTableArray) {
          if (item.key && item.value) {
            symptoms.push(`中焦-${item.key}：${item.value}`)
          }
        }
      }
      if (this.xiajiaoTableArray && this.xiajiaoTableArray.length > 0) {
        for (const item of this.xiajiaoTableArray) {
          if (item.key && item.value) {
            symptoms.push(`下焦-${item.key}：${item.value}`)
          }
        }
      }
      if (symptoms.length > 0) {
        lines.push(`症状信息：`)
        symptoms.forEach(s => lines.push(s))
      }

      // 4. 药方数据（selectDrugList）
      if (!this.selectDrugList || this.selectDrugList.length === 0) {
        lines.push('药方内容：暂无处方数据')
        return lines.join('\n')
      }

      // 过滤掉总计行，取真实药品
      const herbs = []
      let totalCount = 0
      let totalWeight = 0
      for (const item of this.selectDrugList) {
        if (item.label && item.label.length > 0 && item.weight) {
          herbs.push(`${item.label}${item.weight}克`)
          totalCount++
          totalWeight += parseFloat(item.weight) || 0
        }
      }

      lines.push(`药方内容：`)
      lines.push(`药材组成：${herbs.length > 0 ? herbs.join('，') : '暂无药材明细'}`)
      lines.push(`总计：${totalCount}味`)
      lines.push(`饮片重量：${totalWeight}克`)

      return lines.join('\n')
    },
    sendPrescriptionToAi() {
      const text = this.parsePrescriptionToText()

      // 检查解析结果
      if (text.includes('暂无') || text.includes('异常')) {
        this.$message.warning(text)
        return
      }

      // 通过事件总线发送到AI对话框
      EventBus.$emit('ai-input-text', {
        text: text,
        source: 'prescription',
        prescriptionType: '自拟组方',
        patientName: (this.consultInfo && this.consultInfo.name) ? utils.blurName(this.consultInfo.name) : ''
      })

      this.$message.success('处方已填充到AI对话框，可以开始咨询')
    },
    generateTableData() {
      this.tablePrescription = [];
      for (var i = 0; i < this.prescriptions.length; i++) {
        var table_data_item = {};
        var item = this.prescriptions[i];
        table_data_item.count = item.count;
        table_data_item.charge = item.charge;
        table_data_item.totalWeight = item.totalWeight;
        table_data_item.startDate = item.startDate;
        table_data_item.endDate = item.endDate;
        table_data_item.title = item.name;
        table_data_item.type = item.type;
        table_data_item.takeTime = item.takeTime;
        table_data_item.disease = item.disease;
        var itemArray = item.prescription;
        for (var j = 0; j < item.prescription.length; j++) {
          var itemJ = item.prescription[j];
          if (j % 2 == 1) {
            itemArray[j - 1].key1 = itemJ.key;
            itemArray[j - 1].value1 = itemJ.value;
            itemArray[j - 1].index1 = itemJ.index;
            itemArray[j - 1].visible1 = false;
          } else {
            itemArray[j].visible = false;
          }
        }
        var options = [];
        for (var k = 0; k < itemArray.length; k++) {
          if (k % 2 == 0) {
            options.push(itemArray[k]);
          }
        }
        table_data_item.options = options;
        this.tablePrescription.push(table_data_item);
      }
      this.diagnoseResult = this.tablePrescription[0].disease;
      this.takeMedTime = this.tablePrescription[0].takeTime;
      this.diagnosisType = this.tablePrescription[0].diagnosisType;
    },
  },
};
</script>

<style scoped>
/* 单列布局（无侧边栏）：覆盖 ful-body 默认的双列 grid */
.ful-body-single {
  display: block !important;
  grid-template-columns: none !important;
  gap: 0;
}

/* el-table 融入设计系统 */
.ful-el-table {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(23, 61, 59, 0.10);
}

/* 隐藏 el-table 水平滚动条 */
.ful-el-table >>> .el-table__body-wrapper,
.ful-el-table >>> .el-table__body,
.ful-el-table >>> .el-table__inner-wrapper {
  overflow-x: hidden !important;
}

.ful-el-table >>> .el-table__body-wrapper::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

.ful-el-table >>> th {
  background: #f0f7f2 !important;
  color: #304744 !important;
  font-weight: 700;
}

.ful-el-table >>> .total-row {
  background: #f7fbf8 !important;
  font-weight: 700;
  color: #d35845;
}
.ful-el-table >>> .total-row .cell {
  padding: 10px 16px;
  text-align: left;
  font-weight: 700;
  color: #d35845;
}

/* 表格外部：使用方法和禁忌（与总计行视觉连成一片） */
.ful-info-section {
  background: #f7fbf8;
  padding: 10px 16px;
  text-align: right;
  line-height: 1.6;
  border-top: 1px solid #e8efea;
}
.ful-info-section:last-of-type {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.info-row-label {
  color: #007e7f;
  font-weight: 700;
  white-space: nowrap;
  margin-right: 6px;
}
.info-row-value {
  color: #527f77;
  white-space: pre-wrap;
  word-break: break-all;
  text-align: right;
}

/* 底部按钮 disabled 态 */
.ful-btn-draft:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 一键输入AI对话框按钮（蓝底白字） */
.ful-btn-draft {
  background: #1e90ff !important;
  border: 1px solid #1e90ff !important;
  color: #fff !important;
  box-shadow: 0 10px 22px rgba(30, 144, 255, 0.22);
}

.ful-btn-draft:hover {
  background: #1873cc !important;
  border-color: #1873cc !important;
}
</style>
